import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import StaffManagement from "views/admin/tables";
import Opportunities from "views/admin/opportunities";
import ProjectManagement from "views/admin/projects";
import ProjectDetailPage from "views/admin/projects/components/ProjectDetailView";
import ArticlesCMS from "views/admin/articles";
import SecurityLogs from "views/admin/logs";
import Profile from "views/admin/profile";
import GlobalSearch from "views/admin/search";
import LeaveRequestsManagement from "views/admin/requests";

// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import {
  MdDashboard,
  MdGroup,
  MdLibraryBooks,
  MdPerson,
  MdLockOutline,
  MdAdsClick,
  MdRestorePage,
  MdManageSearch,
  MdEventNote,
  MdAccountTree,
} from "react-icons/md";

const routes = [
  {
    name: "Command Hub",
    layout: "/admin",
    path: "default",
    icon: <MdDashboard className="h-6 w-6" />,
    component: <MainDashboard />,
  },
  {
    name: "STAFF MANAGEMENT",
    layout: "/admin",
    path: "staff",
    icon: <MdGroup className="h-6 w-6" />,
    component: <StaffManagement />,
  },
  {
    name: "REQUESTS",
    layout: "/admin",
    path: "requests",
    icon: <MdEventNote className="h-6 w-6" />,
    component: <LeaveRequestsManagement />,
  },
  {
    name: "CRM",
    layout: "/admin",
    path: "crm",
    icon: <MdAdsClick className="h-6 w-6" />,
    component: <Opportunities />,
  },
  {
    name: "PROJECTS",
    layout: "/admin",
    path: "projects",
    icon: <MdAccountTree className="h-6 w-6" />,
    component: <ProjectManagement />,
  },
  {
    name: "PROJECT DETAIL",
    layout: "/admin",
    path: "projects/:id",
    component: <ProjectDetailPage />,
    secondary: true,
  },
  {
    name: "ARTICLES CMS",
    layout: "/admin",
    path: "articles",
    icon: <MdLibraryBooks className="h-6 w-6" />,
    component: <ArticlesCMS />,
  },
  {
    name: "SECURITY LOGS",
    layout: "/admin",
    path: "logs",
    icon: <MdRestorePage className="h-6 w-6" />,
    component: <SecurityLogs />,
  },
  {
    name: "PERSONAL PROFILE",
    layout: "/admin",
    path: "profile",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />,
  },
  {
    name: "SEARCH RESULTS",
    layout: "/admin",
    path: "search",
    icon: <MdManageSearch className="h-6 w-6" />,
    component: <GlobalSearch />,
    secondary: true,
  },
  {
    name: "SYSTEM LOGIN",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLockOutline className="h-6 w-6" />,
    component: <SignIn />,
  },
];

export default routes;
